export default __webpack_public_path__ + "static/media/sg.8e870f1d.svg";